module.exports = __webpack_public_path__ + "static/media/vaccine-policy-ni.f3c3fbed.png";